/**
 * Replace commas in `<>` options
 * @param {String} input
 */
const replaceOptionCommas = (input) => {
  if (input.includes("<")) {
    return input.replace(/<(.*?)>+/g, (/** @type {String} */ string) => {
      if (string.includes("(")) {
        return string.replace(/\((.*?)\)+/g, (item) => {
          return item.replace(/,/g, "▌");
        }).replace(/,/g, "░");
      } else {
        return string.replace(/,/g, "░");;
      }
    });
  } else {
    return input;
  }
}

export default replaceOptionCommas;